import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
  forwardRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'fleet-toggle',
    host: {
      class: 'inline-flex shrink-0 items-center leading-none',
    },
    imports: [CommonModule, ReactiveFormsModule, MatTooltipModule],
    template: `
    <label
      class="relative flex cursor-pointer items-center leading-none"
      [matTooltip]="toolTip"
    >
      <input type="checkbox" class="sr-only peer" [formControl]="control" />

      <div
        class="bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:bg-white after:border-gray-300 after:border after:rounded-full after:transition-all dark:border-gray-600"
        [ngClass]="{
          'bg-primary-600': control.value && !control.disabled,
          'bg-gray-200': !control.value || control.disabled,
          'w-14 h-7  after:h-6 after:w-6': size === 'LARGE',
          'w-9 h-5  after:h-4 after:w-4': size === 'SMALL',
          'w-11 h-6 after:h-5 after:w-5': size === 'DEFAULT',
          'after:top-[2px] after:left-[2px]':
            size === 'SMALL' || size === 'DEFAULT',
          'after:top-0.5 after:left-[4px]': size === 'LARGE'
        }"
      ></div>
    </label>
  `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ToggleComponent),
            multi: true,
        },
    ]
})
export class ToggleComponent implements OnInit, ControlValueAccessor {
  @Input() size: 'SMALL' | 'DEFAULT' | 'LARGE' = 'DEFAULT';
  @Input() toolTip: string;
  control = new FormControl();
  private onChange: any = () => {};
  private onTouched: any = () => {};

  constructor(private changeDetectionRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.control.valueChanges.subscribe((value) => {
      this.onChange(value);
      this.onTouched();
    });
  }

  writeValue(value: boolean): void {
    this.control.setValue(value ? true : false, { emitEvent: false });
    this.changeDetectionRef.detectChanges();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.control.disable({ emitEvent: false });
    } else {
      this.control.enable({ emitEvent: false });
    }
  }
}
